import { ContratoTemplateSignatario } from "./contrato-template-signatario.model";

export class Template {

    templateId: number = 0;

    descricao: string = '';

    html: string = '';

    tpTemplate: TipoTemplate = TipoTemplate.Contrato;

    contratoTemplatePadrao: boolean = false;

    ativo: boolean = true;

    saguiClienteId: number = 0;

    templateEmpresas: any[] = [];

    contratoTemplateSignatarios: ContratoTemplateSignatario[] = [];

    

}


 export enum TipoTemplate
{
    Nfse = 1,
    DemonstrativoQuitacaoDebitos = 2,
    Orcamento = 4,
    Contrato = 6,
    FaturaVenda = 8,
    FaturaCompra = 9,
    ContaReceberRecibo = 16,
    ContaPagarRecibo = 17,
    HistoricoEscolar = 18,
    FuncionarioFicha = 21,
    VeiculoFicha = 22,
    PlanoAula = 23,
    RelatorioAvaliacao = 24
}

            
